// Servicios para manejar las operaciones de API de configuración SKU
import { updateProduct, insertCompetence, deleteCompetence, bulkUpdateCompetenceQty } from '../../../api/configuracionSku';

export const apiService = {
  // Función para actualizar UNIT y QTY de un producto
  async actualizarProducto(productoId, unit, qty) {
    try {
      console.log(`Actualizando producto ${productoId} con unit: ${unit}, qty: ${qty}`);
      
      const response = await updateProduct(productoId, unit, qty);
      console.log('Producto actualizado exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar producto:', error);
      throw error;
    }
  },

  // Función para insertar una competencia para un producto
  async insertarCompetencia(productoId, competenceId) {
    try {
      console.log(`Insertando competencia ${competenceId} para producto ${productoId}`);
      
      const response = await insertCompetence(productoId, competenceId);
      console.log('Competencia insertada exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al insertar competencia:', error);
      throw error;
    }
  },

  // Función para eliminar una competencia de un producto
  async eliminarCompetencia(competenciaId) {
    try {
      console.log(`Eliminando competencia ${competenciaId}`);
      
      const response = await deleteCompetence(competenciaId);
      console.log('Competencia eliminada exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar competencia:', error);
      throw error;
    }
  },

  // Función para actualizar cantidades de competencias en lote
  async actualizarCantidadesCompetencias(updates) {
    try {
      console.log('🔄 Enviando actualización de cantidades de competencias:');
      console.log('📤 Datos enviados:', JSON.stringify({ updates }, null, 2));
      
      const response = await bulkUpdateCompetenceQty(updates);
      console.log('✅ Cantidades de competencias actualizadas exitosamente:', response.data);
      
      // Verificar si realmente se actualizaron
      if (response.data.success && response.data.data) {
        console.log('📊 Detalles de la actualización:', response.data.data);
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Error al actualizar cantidades de competencias:', error);
      throw error;
    }
  }
};
